import audio from '../../../../assets/audio/kids-tracks/Text21.mp3';
import hint29 from '../../../../assets/images/games/zdar-kids-game/hints/29.webp';

export const step30talk = {
    id: 30,
    title: 'Dále',
    taskText: `
        <p>
            Uff, tak to jsme zvládli. Za odměnu nám opat ukázal obrázek věci, 
            kterou musíme najít. Co je to za zvláštní tvar? Vypadá trochu jako prasečí ocásek. 
            Od něj se máme vydat na průzkum kostela, to nám prý pomůže záhadu vyřešit. 
        </p>
    `,
    cipher: {
        text: `
            Pokračujte po cestě, než uvidíte držák na dopravní prostředek. Měl by mít podobný tvar jako nám nakreslil opat.
        `,
        showSquiggle: true,
        label: 'Úkol',
    },
    continueButtonText: 'Jsme u něj',
    points: false,
    audio: audio,
    hints: [
        {
            image: hint29,
        },
    ],
};
